<script setup lang="ts">
import { liveStreamService } from '@/api/services/live-stream-service'
import BaseLayout from '@/components/base/BaseLayout.vue'
import type { LiveStreamDetail } from '@/types/live-stream.types'
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const liveStreamingId = route.params.id
const liveStream = ref<LiveStreamDetail>()

console.log(liveStreamingId)
onMounted(async () => {
  liveStream.value = await liveStreamService.getLiveStreamDetail(Number(liveStreamingId))
  console.log(liveStream.value)
})
</script>

<template>
  <BaseLayout>
    <div class="live-streaming-view">
      <div class="live-streaming-view-header">
        <div style="padding: 56.25% 0 0 0; position: relative">
          <iframe
            :src="liveStream?.vimeoUrl"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowfullscreen
            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
          ></iframe>
        </div>
      </div>
    </div>
  </BaseLayout>
</template>
